import type { Category } from "./unit";

// Base: the kelvin. These four are the only units on the page whose zero is somewhere other than nothing, and the
// offset beside the factor is the whole of what says so: freezing is 273.15 K however it is spelled.
export const TEMPERATURE: Category = {
  id: "temperature",
  label: "Temperature",
  defaultUnit: "c",
  units: [
    // Fahrenheit's zero is 32 of its own degrees below freezing, and each of them is five ninths of a kelvin.
    { id: "c", name: "Celsius", symbol: "°C", factor: 1, offset: 273.15 },
    { id: "f", name: "Fahrenheit", symbol: "°F", factor: 5 / 9, offset: 273.15 - 160 / 9 },
    { id: "k", name: "Kelvin", symbol: "K", factor: 1 },
    { id: "r", name: "Rankine", symbol: "°R", factor: 5 / 9 },
  ],
};
